/**
 * Attach live Adjust-Threshold floors to a /model-responses request body.
 * Empty maps are omitted so the backend keeps the training's saved thresholds.
 */
export function withSelectedThresholdsOverride(requestData, selectedThresholds) {
  if (!selectedThresholds || Object.keys(selectedThresholds).length === 0) {
    return requestData;
  }
  return {
    ...requestData,
    selected_thresholds_override: selectedThresholds,
  };
}
